import React, { memo, useCallback, useRef } from 'react';
import { useForceRender, useObserveRef } from '@chkp/mwc-common';
import clsx from 'clsx';
import { HeaderCell } from './HeaderCell';
import styles from './Header.scss';

let Header = (props) => {
	const {
		store,
		context,
		outline,
		columnsObservable,
		scrollXObservable,
		hasScrollY, // right border is different if there's a vertical scrollbar for slightly better look
	} = props;

	const ref = useRef();

	const columns = columnsObservable.current || null;
	const scrollX = scrollXObservable.current || 0;

	// remember last columns which were rendered. this ref is replaced when columns change.
	// ** during resize, the columns themselves don't change, only their internal 'finalWidth'.
	// This allows to avoid expensive re-renders.
	const renderColumnsRef = useRef(columns);
	const [, forceRender] = useForceRender();

	useObserveRef(columnsObservable, (newColumns) => {
		if (renderColumnsRef.current !== newColumns) {
			renderColumnsRef.current = newColumns;
			forceRender();
		} else {
			Array.from(ref.current.children).forEach((headerCell, idx) => {
				// eslint-disable-next-line no-param-reassign
				headerCell.style.width = `${newColumns[idx]?.finalWidth || 0}px`;
			});
		}
	});

	useObserveRef(scrollXObservable, (scrollX) => {
		ref.current.style.marginLeft = `${-scrollX}px`;
		columnsObservable.current?.forEach((col, idx) => {
			if (col.locked) {
				ref.current.children.item(idx).style.left = `${scrollX}px`;
			}
		});
	});

	return (
		<div
			role='rowgroup'
			className={clsx(
				styles.Header,
				outline && styles.withOutline,
				hasScrollY && styles.withScrollY, // Needed for different right-border color
			)}
		>
			<div
				role={'row'}
				ref={ref}
				className={styles.cellsCt}
				style={{
					marginLeft: -scrollX,
				}}
			>
				{columns &&
					columns.map((column) => (
						<HeaderCell
							key={column.key}
							column={column}
							scrollXObservable={scrollXObservable}
							store={store}
							context={context}
						/>
					))}
			</div>
		</div>
	);
};

Header = memo(Header);

export { Header };
